import React from 'react';
import { AddToHomeScreen, DynamicFeed, FlightTakeoff, AmpStories } from "@material-ui/icons";
import { deepOrange } from '@material-ui/core/colors';

const Services = () => {
    return (
        <section id="services">
            <div className="container">
                <div className="row">
                    <div className="col col-md-12 text-center">
                        <h2 className="text-dark">At Your Service</h2>
                        <hr className="my-4 mx-auto" />
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-lg-3 text-center">
                        <div className="mx-auto service-box mt-5">
                            <AddToHomeScreen style={{ color: deepOrange[600], fontSize: 90 }} />
                            <h3 className="mb-3">Mobile first</h3>
                            <p className="text-muted mb-0">We work on mobile first approach for an ultimate user experience.<br/></p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 text-center">
                        <div className="mx-auto service-box mt-5">
                            <DynamicFeed style={{ color: deepOrange[600], fontSize: 90 }} />
                            <h3 className="mb-3">Dynamic</h3>
                            <p className="text-muted mb-0">Load or store your data dynamically from a secured database.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 text-center">
                        <div className="mx-auto service-box mt-5">
                            <FlightTakeoff style={{ color: deepOrange[600], fontSize: 90 }} />
                            <h3 className="mb-3">Up to Date</h3>
                            <p className="text-muted mb-0">We use latest technologies and update dependencies regularly.</p>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-3 text-center">
                        <div className="mx-auto service-box mt-5">
                            <AmpStories style={{ color: deepOrange[600], fontSize: 90 }} />
                            <h3 className="mb-3">Customisation</h3>
                            <p className="text-muted mb-0">You will get reverything, perfectly customised to satisfy your needs.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Services

